import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Award, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo, certification } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center mr-3">
                <Award className="w-7 h-7 text-white" />
              </div>
              <div>
                <div className="font-bold text-lg">{companyInfo.name}</div>
                <div className="text-xs text-slate-400">General Contractor</div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Kontraktor profesional bersertifikat {certification.standard} yang bergerak di bidang mekanikal dan elektrikal.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Tautan Cepat</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  Beranda
                </Link>
              </li>
              <li>
                <Link to="/tentang" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  Tentang Kami
                </Link>
              </li>
              <li>
                <Link to="/layanan" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  Layanan
                </Link>
              </li>
              <li>
                <Link to="/testimoni" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  Testimoni
                </Link>
              </li>
              <li>
                <Link to="/kontak" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  Kontak
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">Layanan Kami</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>Instalasi Mekanikal</li>
              <li>Instalasi Elektrikal</li>
              <li>Pemeliharaan & Servis</li>
              <li>Konsultasi Teknik</li>
              <li>Pengadaan Material</li>
              <li>Manajemen Proyek</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Hubungi Kami</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0 mt-1" />
                <span className="text-slate-400 text-sm leading-relaxed">{companyInfo.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 text-blue-400 mr-3 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-slate-400 hover:text-white transition-colors duration-300 text-sm">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm text-center md:text-left">
              &copy; {currentYear} {companyInfo.name}. Hak Cipta Dilindungi.
            </p>
            <div className="flex items-center gap-2 text-xs text-slate-500">
              <span>Sertifikat: {certification.certificateNo}</span>
              <span>|</span>
              <span>ISO {certification.standard}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
